import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import classNames from "classnames";
import { useCSSProperty, useHeight, useStoreLocatorContext } from "../../hooks";
import { useDisplayType } from "../../hooks/useDisplayType";
import { StoreLocatorCardList } from "../StoreLocatorCardList";
import { StoreLocatorMap } from "../StoreLocatorMap";
import { StoreLocatorSearchBarV2 } from "../StoreLocatorSearchBarV2";
import { ViewSwitch } from "../ViewSwitch";
import styles from "./StoreLocatorV2.module.scss";
export const StoreLocatorV2 = () => {
    const { isMapActive } = useStoreLocatorContext();
    const { change, isList, isMap } = useDisplayType("map");
    const { ref: topBarRef, height } = useHeight();
    const storeRef = useCSSProperty("--storeLocatorTopBarHeight", isMapActive ? `-${height}px` : "unset", [
        height,
        isMapActive,
    ]);
    const mainRef = useRef();
    return (_jsxs("div", { className: classNames(styles.storeLocator, { [styles.storeLocatorFixedHeight]: isMap }), ref: storeRef, children: [_jsx("div", { className: classNames(styles.top, { [styles.hide]: isMapActive && isMap }), ref: topBarRef, children: _jsx("div", { className: classNames(styles.wrapper), children: _jsx(StoreLocatorSearchBarV2, {}) }) }), _jsxs("div", { className: classNames(styles.main), ref: mainRef, children: [_jsx("div", { className: classNames(styles.wrapper, styles.desktopHidden), children: _jsx(ViewSwitch, { className: classNames(styles.viewSwitch, {
                                [styles.viewSwitchOnMap]: isMap,
                                [styles.fullSize]: isMapActive && isMap,
                            }), onChangeResultType: change }) }), _jsxs("div", { className: classNames(styles.wrapper, styles.grid), children: [_jsx("div", { className: classNames({
                                    [styles.mobileHidden]: !isList,
                                }), children: _jsx(StoreLocatorCardList, { isMapView: isMap, mapWrapperRef: mainRef }) }), _jsx(StoreLocatorMap, { className: classNames(styles.map, { [styles.mobileHidden]: !isMap }) })] })] })] }));
};
//# sourceMappingURL=StoreLocatorV2.js.map